import type { CustomerLanguage } from "@/lib/customer-language";

const MATCHING_COPY = {
  en: {
    personA: "Person A",
    personB: "Person B",
    nextPersonB: "Next: Enter Person B",
    calculate: "Calculate Gun Milan",
    change: "Change",
    loading: "Calculating Ashtakoot Gun Milan...",
    loadingDetail: "Generating kundalis and matching all 8 kootas",
    genericError: "Something went wrong",
    detailedError: "Failed to generate detailed report",
    compatibility: "compatibility",
    moon: "Moon",
    nakshatra: "Nakshatra",
    lagna: "Lagna",
    kootaBreakdown: "Ashtakoot (8 Koota) Breakdown",
    mangalStatus: "Mangal Dosha Status",
    mangalMeaning: "What does Mangal Dosha mean for this match?",
    recommendation: "Recommendation",
    deeperTitle: "Want Deeper Insights?",
    deeperBody:
      "Get Navamsha (D9) chart analysis, Dasha compatibility for the next 5 years, Dosha cross-check, and personalised upay recommendations.",
    deeperLoading: "Analysing charts...",
    deeperCta: "Get Detailed Report",
    navamshaAnalysis: "Navamsha Analysis",
    dashaCompatibility: "Dasha Compatibility",
    doshaCrosscheck: "Dosha Cross-Check",
    upayRecommendations: "Upay Recommendations",
    comprehensiveCompatibility: "Comprehensive Compatibility",
    challengingPeriods: "Challenging Periods Ahead",
    recommendedUpay: "Recommended Upay",
    generatingPdf: "Generating PDF...",
    downloadPdf: "Download PDF Report",
    pdfError:
      "The PDF could not be downloaded. Your results are still here. Please try downloading again.",
    fullReport: "Get Full Kundali Reading →",
    matchAnother: "Match Another Pair",
    modeBirth: "By birth details",
    modeNaam: "By naam (no birth time)",
    naamIntro:
      "Enter each person's name, or their naam-akshar if you know it. We will confirm which nakshatra it points to before showing any score.",
    naamNameLabel: "Full name",
    naamAksharLabel: "Naam-akshar",
    naamIsNameOption: "This is a name",
    naamIsAksharOption: "This is the akshar",
    naamCheck: "Check naam-akshar",
    naamChecking: "Checking the naam-akshar table...",
    naamCalculate: "Calculate Gun Milan",
    naamChooseHeading: "Which nakshatra is this akshar?",
    naamChooseBody:
      "This akshar belongs to more than one nakshatra, and they do not give the same score. Pick the one from the naamkaran.",
    naamNotFoundHeading: "This akshar is not in the naam-akshar table",
    naamNotFoundBody:
      "Joined syllables like Vrinda or Pragya have no cell of their own. Pick the naamkaran akshar from the list instead.",
    naamPickerOpen: "Pick from the akshar list",
    naamPickerClose: "Close the list",
    naamConfirmed: "Confirmed",
    naamChange: "Change",
    naamPada: "pada",
    naamBoundaryHeading: "What this score can and can't tell you",
    naamBoundaryPremise:
      "This is the Gun Milan your two naam-akshar point to — it is not a birth-time match.",
    naamBoundaryJanma:
      "Naam milan traditionally uses the janma naam: the syllable given at naamkaran, chosen from the birth nakshatra. Most people's everyday name was never chosen that way — so if these akshar didn't come from the naamkaran, the nakshatra behind this score isn't yours either.",
    naamBoundaryMangal:
      "Mangal Dosh is not checked here. That needs Mars's house placement, which only a full kundali gives.",
    naamSwitchToBirth: "Match with exact birth time",
    naamGenericError: "Something went wrong",
  },
  // Devanagari on /hi/ (owner decision 2026-10-28, replacing the 2026-10-08
  // Hinglish rule); tests/hindi-register.test.ts guards this block.
  hi: {
    personA: "पहली कुंडली",
    personB: "दूसरी कुंडली",
    nextPersonB: "आगे: दूसरी कुंडली भरें",
    calculate: "गुण मिलान करें",
    change: "बदलें",
    loading: "अष्टकूट गुण मिलान की गणना हो रही है...",
    loadingDetail: "दोनों कुंडलियाँ और सभी 8 कूट मिलाए जा रहे हैं",
    genericError: "कुछ ठीक नहीं चला। दोबारा कोशिश करें।",
    detailedError: "विस्तृत रिपोर्ट नहीं बन पाई। दोबारा कोशिश करें।",
    compatibility: "मिलान",
    moon: "चंद्र",
    nakshatra: "नक्षत्र",
    lagna: "लग्न",
    kootaBreakdown: "अष्टकूट के 8 कूट",
    mangalStatus: "मंगल दोष की स्थिति",
    mangalMeaning: "इस मिलान के लिए मंगल दोष का क्या मतलब है?",
    recommendation: "ज्योतिषीय मार्गदर्शन",
    deeperTitle: "मिलान को और गहराई से समझें",
    deeperBody: "नवांश (D9), अगले 5 साल की दशा अनुकूलता, दोष की जाँच और आपके लिए उपाय देखें।",
    deeperLoading: "दोनों कुंडलियों का विश्लेषण हो रहा है...",
    deeperCta: "विस्तृत रिपोर्ट देखें",
    navamshaAnalysis: "नवांश विश्लेषण",
    dashaCompatibility: "दशा अनुकूलता",
    doshaCrosscheck: "दोष की जाँच",
    upayRecommendations: "सुझाए गए उपाय",
    comprehensiveCompatibility: "पूरी अनुकूलता",
    challengingPeriods: "आगे के कठिन समय",
    recommendedUpay: "सुझाए गए उपाय",
    generatingPdf: "PDF बन रही है...",
    downloadPdf: "PDF रिपोर्ट डाउनलोड करें",
    pdfError: "PDF डाउनलोड नहीं हो सकी। आपके परिणाम यहीं हैं। कृपया दोबारा डाउनलोड करें।",
    fullReport: "पूरी कुंडली का फल देखें →",
    matchAnother: "दूसरा मिलान करें",
    modeBirth: "जन्म विवरण से",
    modeNaam: "नाम से (जन्म समय के बिना)",
    naamIntro:
      "दोनों का नाम लिखें, या नाम-अक्षर पता हो तो वही। स्कोर दिखाने से पहले हम पक्का करेंगे कि वह किस नक्षत्र का है।",
    naamNameLabel: "पूरा नाम",
    naamAksharLabel: "नाम-अक्षर",
    naamIsNameOption: "यह नाम है",
    naamIsAksharOption: "यह अक्षर है",
    naamCheck: "नाम-अक्षर जाँचें",
    naamChecking: "नाम-अक्षर तालिका जाँची जा रही है...",
    naamCalculate: "गुण मिलान करें",
    naamChooseHeading: "यह अक्षर किस नक्षत्र का है?",
    naamChooseBody:
      "यह अक्षर एक से ज़्यादा नक्षत्रों का है, और उनके स्कोर अलग आते हैं। नामकरण वाला चुनें।",
    naamNotFoundHeading: "यह अक्षर नाम-अक्षर तालिका में नहीं है",
    naamNotFoundBody:
      "वृंदा या प्रज्ञा जैसे संयुक्त अक्षरों का अलग खाना नहीं होता। सूची से नामकरण वाला अक्षर चुनें।",
    naamPickerOpen: "अक्षर सूची से चुनें",
    naamPickerClose: "सूची बंद करें",
    naamConfirmed: "पक्का",
    naamChange: "बदलें",
    naamPada: "पद",
    naamBoundaryHeading: "यह स्कोर क्या बता सकता है, और क्या नहीं",
    naamBoundaryPremise:
      "यह गुण मिलान आप दोनों के नाम-अक्षर से निकला है — यह जन्म समय से किया गया मिलान नहीं है।",
    naamBoundaryJanma:
      "पारंपरिक नाम मिलान जन्म नाम पर होता है: वह अक्षर जो नामकरण में जन्म नक्षत्र से चुना जाता है। अक्सर रोज़ का नाम इस तरह नहीं चुना जाता — इसलिए अगर ये नामकरण वाले अक्षर नहीं हैं, तो स्कोर के पीछे का नक्षत्र भी आपका नहीं होगा।",
    naamBoundaryMangal:
      "मंगल दोष यहाँ नहीं जाँचा गया। इसके लिए मंगल का भाव चाहिए, जो पूरी कुंडली से मिलता है।",
    naamSwitchToBirth: "सही जन्म समय से मिलान करें",
    naamGenericError: "कुछ ठीक नहीं चला। दोबारा कोशिश करें।",
  },
} as const;

export function matchingCopy(language: CustomerLanguage) {
  return MATCHING_COPY[language];
}
